import api from '../services/api';

interface IDownloadExcel {
  template: string;
  dados: any;
  reportName: string;
}

export const downloadExcel = async ({
  dados,
  reportName,
  template,
}: IDownloadExcel): Promise<boolean> => {
  const payload = {
    template,
    dados,
    reportName,
  };

  try {
    const response = await api.post('/reports/generate-excel', payload, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${reportName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 2000);

    return true;
  } catch (error) {
    return false;
  }
};
